// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cartNotification = document.querySelector('cart-notification');
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       const submitButton = this.querySelector('[type="submit"]');
//       if (submitButton.classList.contains('loading')) return; 

//       this.handleErrorMessage();
//       this.cartNotification.setActiveElement(document.activeElement);

//       submitButton.setAttribute('aria-disabled', true);
//       submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       config.body = JSON.stringify({
//         ...JSON.parse(serializeForm(this.form)),
//         sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
//         sections_url: window.location.pathname
//       });
// if (FormData) {
// delete config.headers['Content-Type'];
// const formData = new FormData(this.form);
// formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
// formData.append('sections_url', window.location.pathname);
// config.body = formData;
// }


//       fetch(`${routes.cart_add_url}`, config)
//         .then((response) => response.json())
//         .then((response) => {
//           if (response.status) {
//             this.handleErrorMessage(response.description);
//             return;
//           }

//           this.cartNotification.renderContents(response);
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButton.classList.remove('loading');
//           submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//     handleErrorMessage(errorMessage = false) {
//       this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//       this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//       this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//       if (errorMessage) {
//         this.errorMessage.textContent = errorMessage;
//       }
//     }
//   });
// }








if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // Lazy lookup — moved to onSubmitHandler to avoid timing issues
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // Lazy lookup — by submit time, cart-notification.js is fully loaded
      if (!this.cartNotification) {
        this.cartNotification = document.querySelector('cart-notification');
      }

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification
          ? this.cartNotification.getSectionsToRender().map((section) => section.id)
          : [],
        sections_url: window.location.pathname
      });

      if (typeof FormData !== 'undefined') {
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cartNotification) {
          formData.append(
            'sections',
            this.cartNotification.getSectionsToRender().map((s) => s.id)
          );
        }
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification) {
            this.cartNotification.renderContents(response);
          }

          // Re-render the Oddit cart drawer via Section Rendering API
          this.refreshCartDrawer();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    refreshCartDrawer() {
      // Find the cart drawer section ID from the DOM
      const drawerEl = document.querySelector('[data-cart-drawer]');
      if (!drawerEl) return;

      const sectionId = drawerEl.closest('.shopify-section')
        ? drawerEl.closest('.shopify-section').id.replace('shopify-section-', '')
        : null;

      if (!sectionId) {
        // Fallback: just open the drawer if section ID not found
        this.openCartDrawer();
        return;
      }

      // Fetch re-rendered section HTML from Shopify
      fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then((r) => r.json())
        .then((sections) => {
          const html = sections[sectionId];
          if (!html) {
            this.openCartDrawer();
            return;
          }

          // Parse and inject the new drawer HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newDrawer = doc.querySelector('[data-cart-drawer]');

          if (newDrawer && drawerEl) {
            // Replace inner content only, preserving the wrapper
            drawerEl.innerHTML = newDrawer.innerHTML;
          }

          // Update cart count in header
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              document.querySelectorAll('[data-cart-count], [data-cart-total-items]').forEach((el) => {
                el.textContent = cart.item_count;
              });
            });

          // Open the drawer
          this.openCartDrawer();
        })
        .catch(() => {
          // Fallback: just open the drawer
          this.openCartDrawer();
        });
    }

    openCartDrawer() {
      const drawerEl = document.querySelector('[data-cart-drawer]');
      if (!drawerEl) return;

      // Try the oddit drawer JS API first
      if (typeof window.cartDrawer !== 'undefined' && typeof window.cartDrawer.open === 'function') {
        window.cartDrawer.open();
        return;
      }

      // Fallback: dispatch custom event that oddit-section-cart-drawer.js listens for
      document.dispatchEvent(new CustomEvent('cart:open'));

      // Fallback: click the cart toggle button
      const toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) {
        toggle.click();
        return;
      }

      // Last resort: manually add is-open class
      drawerEl.classList.add('is-open');
      drawerEl.style.display = '';
      document.body.classList.add('cart-drawer-open');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}